import { useEffect, useRef, useContext } from "react";
import useState from "react-usestateref";
import Header from "./Header";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Link, useNavigate } from "react-router-dom";
import { verifyAuth } from "../services/authservices";
import authService from "../services/authservices";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";
import Affiliate from "./Affiliate";

const TermsOfService = () => {
  const navigate = useNavigate();
  const [offset, setOffset] = useState(0);
  const advanceSectionRef = useRef(null);
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);


  useEffect(() => {
    const handleScroll = () => {
      if (advanceSectionRef.current) {
        const sectionTop = advanceSectionRef.current.offsetTop;
        const sectionHeight = advanceSectionRef.current.offsetHeight;
        const pageOffset = window.pageYOffset;

        if (
          pageOffset >= sectionTop &&
          pageOffset <= sectionTop + sectionHeight
        ) {
          setOffset(pageOffset - sectionTop);
        } else {
          setOffset(0);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    checkuserAuth();
  }, [0]);

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) { }
  };

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token != null) {
      try {
        const data = await verifyAuth(token);
        if (data && data.status) {
          setAuth(true);
        } else {
          setAuth(false);
        }
      } catch (error) {
        console.error("Error auth user details:", error);
        setAuth(false);
      }
    } else {
      setAuth(false);
    }
  };
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const nav_page = () => {
    if (!userAuthref.current) {
      navigate("/register");
    } else {
      navigate("/home");
    }
  };
  return (
    <>
      <main className="wyscale_landing_main">
        <section>
          <Header />
        </section>

        <section className="dashboard_content_section">
          <div className="container">
            <div className="smart_dashboard_content" id="terms-condition">
              <h2>{t("BinargeTermsOfService")}</h2>
              <p>{t("termsdate")}</p>
              <p>{t("termsdatep")}</p>
              <div className="row">
                <div className="col-lg-12">
                  <div className="dash_board_profile_content">
                    <div className="contentpage">

                      <h3>1. {t("Introduction")} </h3>
                      {/* <h4>NOTICE:</h4> */}
                      <p>{t("WelcomeToBinarge")}</p>

                      <h3>2. {t("ServiceDescription")}</h3>
                      <p>{t("CryptocurrencyTrading")}</p>
                      <p>{t("list heading")}</p>
                      <ul>
                          {t("cryptocurrencyList1") &&<li>{t("cryptocurrencyList1")}</li>}
                          {t("cryptocurrencyList2") &&<li>{t("cryptocurrencyList2")}</li>}
                          {t("cryptocurrencyList3") &&<li>{t("cryptocurrencyList3")}</li>}
                          {t("cryptocurrencyList4") &&<li>{t("cryptocurrencyList4")}</li>}
                          {t("cryptocurrencyList5") &&<li>{t("cryptocurrencyList5")}</li>}
                          {t("cryptocurrencyList6") &&<li>{t("cryptocurrencyList6")}</li>}
                          </ul>
                      <p>{t("CryptocurrencyTrading2")}</p>

                      <h3>3. {t("UserEligibility")}</h3>
                      <p>{t("YouMustBeLeas1t")}</p>


                      <h3>4. {t("AccountAndSecurity")}</h3>
                      <p>{t("YouAreResponsible")} </p> 
                      <p>
                        {t("YouAreResponsible1")}{" "}
                      </p>
                      {t("accountList1") && 
                      <ul>{t("accountList1") &&<li>{t("accountList1")}</li>}
                          {t("accountList2") &&<li>{t("accountList2")}</li>}
                          {t("accountList3") &&<li>{t("accountList3")}</li>}</ul>}
                           <p>{t("YouAreResponsible2")} </p>


                      <h3>5. {t("APIConnections")}</h3>
                      <p>{t("BinargeOperates")}</p>
                      <ul><li>{t("operateList")}</li></ul>
                      <ul><li>{t("operateList2")}</li></ul>
                      <p>{t("BinargeOperates2")}</p>

                      <h3>6. {t("Subscription")}</h3>
                      <p>{t("BinargeOffers")}</p>



                      {/* <h3>7. {t("ProfitSharing")}</h3>
                      <p>{t("BinargeUses")}</p> */}


                      <h3>7. {t("Pre-PaymentBalance")}</h3>
                      <p>{t("pre-PaymentBalanceperformance")}</p>
                      <ul><li>{t("usesList")}</li></ul>
                      <ul><li>{t("usesList2")}</li></ul>
                      <p>{t("Pre-PaymentBalanceperformance1")}</p>
                      <p>{t("Pre-PaymentBalanceperformance2")}</p>
                      <p>{t("Pre-PaymentBalanceperformance3")}</p>



                      <h3>8. {t("affiliateProgram")}</h3>
                      <p>{t("affilateFollow1")}</p>
                      <p>{t("affilateFollow")}</p>
                      <ul>
                        {t("affiliateProgramCurrency1") && <li>{t("affiliateProgramCurrency1")}</li>}
                        {t("affiliateProgramCurrency2") && <li>{t("affiliateProgramCurrency2")}</li>}
                        {t("affiliateProgramCurrency3") && <li>{t("affiliateProgramCurrency3")}</li>}</ul>

                      <h3>9. {t("RiskDisclaimer")}</h3>
                      <p>{t("TradingCryptocurrencies0")}</p>
                      <p>{t("TradingCryptocurrencies")}</p>
                      {/* <p>{t("TradingCryptocurrencies follows")}</p> */}
                      <ul>
                          {t("TradingCryptocurrencies1") && <li>{t("TradingCryptocurrencies1")}</li>}
                          {t("TradingCryptocurrencies2") && <li>{t("TradingCryptocurrencies2")}</li>}
                          {t("TradingCryptocurrencies3") && <li>{t("TradingCryptocurrencies3")}</li>}
                          {t("TradingCryptocurrencies4") && <li>{t("TradingCryptocurrencies4")}</li>}
                          {t("TradingCryptocurrencies5") && <li>{t("TradingCryptocurrencies5")}</li>}
                          {t("TradingCryptocurrencies6") && <li>{t("TradingCryptocurrencies6")}</li>}
                          {t("TradingCryptocurrencies7") && <li>{t("TradingCryptocurrencies7")}</li>}
                          </ul>

                      <h3>10. {t("NoFinancialAdvice")}</h3>
                      <p>{t("FinanciaAdvisor")}</p>

                      <h3>11. {t("ProhibitedUse")}</h3>
                      <p>{t("activities")}</p>
                      <ul>
                          {t("Prohibited list1") && <li>{t("Prohibited list1")}</li>}
                          {t("Prohibited list2") && <li>{t("Prohibited list2")}</li>}
                          {t("Prohibited list3") && <li>{t("Prohibited list3")}</li>}
                          {t("Prohibited list4") && <li>{t("Prohibited list4")}</li>}
                          {t("Prohibited list5") && <li>{t("Prohibited list5")}</li>}
                          {t("Prohibited list6") && <li>{t("Prohibited list6")}</li>}
                          </ul>


                      <h3>12. {t("Termination")}</h3>
                      <p>{t("WeReserveTheRight")}</p>

                      <h3>13. {t("ChangesToTerms")}</h3>
                      <p>{t("BinargeMayRevise")}</p>

                      <h3>14. {t("Governing Law")}</h3>
                      <p>{t("governed by")}</p>

                      <h3>15. {t("ContactInformation")}</h3>
                      <p>{t("ForQuest1")}</p>
                      <p>{t("ForQuest2")}</p>
                      <p>{t("ForQuest3")}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <SubFooter />
      </main>
    </>
  );
};

export default TermsOfService;
